import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  isResetPassSearchFlag,
  isVerifySearchFlag,
  resolveVerifyEntry,
  searchParamsToVerifySearch,
} from "../../utils/loginVerifyUtils";
import { resolveDeepLinkVerificationCode } from "../../utils/deepLinkVerificationCode";

export function usePasswordResetDeepLink() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const search = searchParamsToVerifySearch(searchParams);
  const resetDeepLinkActive =
    isResetPassSearchFlag(search.isResetPass) && Boolean(search.email);
  const resetVerifyEmail = search.email ?? "";
  const verificationCodeFromUrl = resetDeepLinkActive
    ? resolveDeepLinkVerificationCode("reset", resetVerifyEmail, search.code)
    : "";
  const verifyEntry = resolveVerifyEntry(search);
  const resetVerifyEntry = verifyEntry?.mode === "reset" ? verifyEntry : null;
  const showResetVerify = resetDeepLinkActive || Boolean(resetVerifyEntry);

  useEffect(() => {
    if (!isVerifySearchFlag(search.isVerify) || !search.email) {
      return;
    }

    const params = new URLSearchParams({
      isVerify: "true",
      email: search.email,
      ...(search.code ? { code: search.code } : {}),
    });
    navigate(`/register?${params.toString()}`, { replace: true });
  }, [navigate, search.isVerify, search.email, search.code]);

  useEffect(() => {
    if (!resetDeepLinkActive || !search.email || !search.code) {
      return;
    }

    const params = new URLSearchParams({
      isResetPass: "true",
      email: search.email,
    });
    navigate(`/login?${params.toString()}`, { replace: true });
  }, [navigate, resetDeepLinkActive, search.code, search.email]);

  return { showResetVerify, resetVerifyEmail, verificationCodeFromUrl };
}
